"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ObjectId = require('bson').ObjectID;
var clone = require('clone');
var tv4 = require('tv4');
var InventoryReference = require('./inventory-reference');
var PersonReference = require('../core/person-reference');
var Request = /*#__PURE__*/function () {
  function Request(opt) {
    _classCallCheck(this, Request);
    this.status = null;
    this.name = null;
    this.familyId = null;
    this.inventory = null;
    this.type = null;
    this.requestedBy = null;
    this.requestedDate = new Date();
    this.message = null;
    this.sendTo = [];
    if (opt) {
      this.fillObject(clone(opt));
    }
  }
  _createClass(Request, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.status = opt.status ? opt.status : 'OPEN';
      this.name = opt.name || null;
      this.familyId = opt.familyId ? new ObjectId(opt.familyId) : null;
      this.inventory = new InventoryReference(opt.inventory);
      this.type = opt.type || null;
      this.requestedBy = opt.requestedBy ? new PersonReference(opt.requestedBy) : null;
      this.message = opt.message || null;
      this.sendTo = Array.isArray(opt.sendTo) ? opt.sendTo.map(function (inventory) {
        return new InventoryReference(inventory);
      }) : [];
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Request.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'request.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          inventory: {
            $ref: 'inventory-reference.schema.json'
          },
          message: {
            type: 'string'
          },
          name: {
            type: 'string'
          },
          familyId: {
            type: 'object'
          },
          requestedBy: {
            $ref: 'person-reference.schema.json'
          },
          requestedDate: {
            type: 'object'
          },
          sendTo: {
            type: 'array',
            item: {
              $ref: 'inventory-reference.schema.json'
            }
          },
          status: {
            type: 'string'
          },
          type: {
            type: 'string'
          }
        },
        required: ['status', 'name', 'familyId', 'inventory', 'type', 'requestedBy', 'requestedDate', 'message', 'sendTo']
      };
    }
  }]);
  return Request;
}();
tv4.addSchema(InventoryReference.schema());
tv4.addSchema(PersonReference.schema());
module.exports = Request;